export default {"src":"/_next/static/media/neutral.2f124a39.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};